import React from 'react';

const CompanyDomainFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 17H3V3H15V7.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7 17V12H9.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M6.5 6.5H11M6.5 9H10" strokeLinecap="round" strokeWidth="1.5" />
      <path
        d="M15 17.75C17.0711 17.75 18.75 16.0711 18.75 14C18.75 11.9289 17.0711 10.25 15 10.25C12.9289 10.25 11.25 11.9289 11.25 14C11.25 16.0711 12.9289 17.75 15 17.75Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.40625"
      />
      <path d="M11.25 14H18.75" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.40625" />
      <path
        d="M15 10.25C15.8794 11.2769 16.3791 12.6095 16.4062 14C16.3791 15.3905 15.8794 16.7231 15 17.75C14.1206 16.7231 13.6209 15.3905 13.5938 14C13.6209 12.6095 14.1206 11.2769 15 10.25V10.25Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.40625"
      />
    </svg>
  );
};

export default CompanyDomainFilterIcon;
